import React from 'react'

import { AppRoutes } from './common/routes/routes'

export const App: React.FC = () => <AppRoutes />
